export const createPostsSlice = (set, get) => ({
    posts: {
        loading: false,
        data: [],
        single: {},
        selectedId: null
    },
    GET_POSTS_SUCCESS: (payload) => set(state => ({
        posts: {
            ...state.posts,
            data: payload,
            loading: false
        }
    })),
    JOB_POSTS_SUCCESS: (payload) => set(state => ({
        posts: {
            ...state.posts,
            data: payload,
            loading: false
        }
    })),
    GET_POST_SUCCESS: (payload) => set(state => ({
        posts: {
            ...state.posts,
            single: payload,
            loading: false
        }
    })),
    BLOG_LOADING: (payload) => set(state => ({
        posts: {
            ...state.posts,
            loading: payload
        }
    })),
});